<script>
  import { user } from "../../../stores/user";
  import { auth } from "../../../firebase";
  import { panelController, dataReset } from "../../../stores/service";
  import { link } from "svelte-routing";
  import ConfigService from "./ConfigService.svelte";
  import Notificaciones from "./Notificaciones/Notificaciones.svelte";

  document.title = "Ratingg | Mi restaurante";

  const cerrarSesion = () => {
    $panelController = dataReset();
    auth.signOut();
    user.setUser(null);
    $panelController.viewLogin.roluser = 4;
    window.location.reload();
  };
</script>

<div class="mi-restaurante">
  {#if $user}
    <div class="account-bar">
      <img src={$user.photoURL} alt="" class="account-photo" />
      <div class="account-info">
        <strong>{$user.displayName}</strong>
        <span>{$user.email}</span>
      </div>
      {#if $panelController.viewLogin.roluser === 1}
        <a use:link href="/config/roles" class="btn btn-xs btn-outline-secondary">
          Roles
        </a>
      {/if}
      <button class="btn btn-xs btn-outline-danger" on:click={cerrarSesion}>
        Salir
      </button>
    </div>
  {/if}

  <section>
    <h2 class="section-title">Mi restaurante</h2>
    <ConfigService />
  </section>

  <section>
    <h2 class="section-title">Notificaciones</h2>
    <Notificaciones />
  </section>
</div>

<style>
  .mi-restaurante {
    max-width: 720px;
    margin: 0 auto;
    padding-bottom: 1.5rem;
  }

  /* Embedded sections nest Bootstrap rows; drop their negative margins so
     nothing pushes the page sideways. */
  .mi-restaurante :global(.row .row) {
    margin-left: 0;
    margin-right: 0;
  }

  .account-bar {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid rgba(44, 51, 32, 0.12);
  }

  .account-photo {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    object-fit: cover;
    flex: none;
  }

  .account-info {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    line-height: 1.2;
    font-size: 0.9rem;
  }

  .account-info strong,
  .account-info span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .account-info span {
    color: #83805f;
    font-size: 0.75rem;
  }

  .btn-xs {
    padding: 0.15rem 0.55rem;
    font-size: 0.78rem;
  }

  section {
    padding: 1rem 0;
    border-bottom: 1px solid rgba(44, 51, 32, 0.12);
  }

  section:last-child {
    border-bottom: 0;
  }

  .section-title {
    font-size: 1rem;
    font-weight: 700;
    color: #2c3320;
    margin: 0 0 0.6rem;
  }
</style>
